<template>
    <a-modal title="支付中心" :confirmLoading="state.loading" centered :bodyStyle="{ padding: '20px' }" :width="1000"
        :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button :loading="state.loading" type="primary">确定</a-button>
            </a-popconfirm>
        </template>
        <a-form ref="ruleForm" :rules="rules" :model="formState" v-bind="formLayout" scrollToFirstError="true">
            <a-form-item label="主体名称">
                {{ props.tableColumnsData.full_name }}
                <a-tag class="ant-tag-green" v-if="props.tableColumnsData.exception_flag == 1">正常状态</a-tag>
                <a-tag class="ant-tag-red" v-else-if="props.tableColumnsData.exception_flag == 2">待申报异常【代理商待确认①】</a-tag>
                <a-tag class="ant-tag-red"
                    v-else-if="props.tableColumnsData.exception_flag == 3">待申报异常【代理商已确认，公司待确认②】</a-tag>
                <a-tag class="ant-tag-red"
                    v-else-if="props.tableColumnsData.exception_flag == 4">待申报异常【代理商、公司已确认，准备提交资料③】</a-tag>
                <a-tag class="ant-tag-red"
                    v-else-if="props.tableColumnsData.exception_flag == 5">已申报异常【已交资料，待确认是否地址异常】</a-tag>
                <a-tag class="ant-tag-red" v-else-if="props.tableColumnsData.exception_flag == 6">人工已确认地址已异常</a-tag>
            </a-form-item>

            <a-form-item label="历史名称" v-if="props.tableColumnsData.history_names?.length > 0">
                <div v-for="(item, index) in props.tableColumnsData.history_names" :key="index">
                    {{ item }}
                </div>
            </a-form-item>

            <a-form-item label="注册地址">
                {{ props.tableColumnsData.full_address_number }}
            </a-form-item>

            <a-form-item label="代理商" name="belonger" required>
                {{ formState.belonger }}
            </a-form-item>
            <a-form-item label="备注" v-if="props.tableColumnsData.remark">
                {{ props.tableColumnsData.remark }}
            </a-form-item>

            <a-form-item label="当前托管时间"> {{ props.tableColumnsData.enter_starttime.substr(0, 10) }} ~ <span
                    v-html="props.tableColumnsData.enter_endtime"></span> </a-form-item>
            <a-form-item label="支付类型" required>
                <a-radio-group v-model:value="formState.public_payment_type" button-style="solid"
                    @change="getComputeOreder">
                    <a-radio-button :value="2">地址续费</a-radio-button>
                    <a-radio-button :value="1">支付注册费</a-radio-button>
                    <a-radio-button :value="3">其它收入（核查表，移除异常等等）</a-radio-button>
                </a-radio-group>
            </a-form-item>
            <!-- 其他支付的支付名称+金额 + 附加工单 -->
            <div v-if="formState.public_payment_type == 3">
                <a-form-item label="支付名称" extra="" name="other_name" required>
                    <a-select allow-clear v-model:value="formState.other_name" placeholder="请选择支付名称"
                        @change="getComputeOreder">
                        <a-select-option value="核查表">核查表</a-select-option>
                        <a-select-option value="移除异常">移除异常</a-select-option>
                        <a-select-option value="申请迁入走现场">申请迁入走现场</a-select-option>
                        <a-select-option value="小规模转一般纳税人">小规模转一般纳税人</a-select-option>
                        <a-select-option value="其它">其它(补收款)</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="支付金额" name="other_amount" required>
                    <a-input placeholder="" v-model:value="formState.other_amount" prefix="￥" suffix="元"
                        style="width: 140px" @blur="getComputeOreder"
                        :readonly="formState.other_name == '小规模转一般纳税人'"></a-input>
                    <!-- 附加工单 -->
                    <br />
                    <a-button v-if="!formState.is_work_order" class="mt-2x"
                        @click="() => (formState.is_work_order = true)" type="primary">附加工单</a-button>
                    <a-button v-if="formState.is_work_order" class="mt-2x"
                        @click="() => (formState.is_work_order = false)" type="primary">取消附加工单</a-button>
                </a-form-item>
                <div v-if="formState.is_work_order">
                    <a-form-item label="工单类型" required>
                        <a-select allow-clear ref="select" v-model:value="formState.wo_type">
                            <a-select-option :value="1">经营纠纷</a-select-option>
                            <a-select-option :value="2">网络卖课</a-select-option>
                            <a-select-option :value="3">疑似诈骗</a-select-option>
                            <a-select-option :value="4">疑似银行类犯罪</a-select-option>
                            <a-select-option :value="5">其它类型</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="归属销售" name="reception_admin_ids" required>
                        <UserPick v-model:value="formState.reception_admin_ids" mode="multiple"
                            placeholder="请输入归属销售姓名或手机号码">
                        </UserPick>
                    </a-form-item>
                    <a-form-item label="工单执行负责人" name="custodian_admin_ids" required>
                        <UserPick v-model:value="formState.custodian_admin_ids" mode="multiple"
                            placeholder="请输入工单执行负责人姓名或手机号码">
                        </UserPick>
                    </a-form-item>
                    <a-form-item label="开始时间" name="start_time" required>
                        <a-date-picker :show-time="{ defaultValue: arrayMonent }" v-model:value="formState.start_time"
                            placeholder="请选择开始日期"></a-date-picker>
                    </a-form-item>
                    <a-form-item label="截止完成时间" name="end_time" required>
                        <a-date-picker :show-time="{ defaultValue: arrayMonent }" v-model:value="formState.end_time"
                            placeholder="请选择截止日期"></a-date-picker>
                    </a-form-item>
                    <a-form-item label="工单内容" name="content" required>
                        <a-input placeholder="请输入工单内容" v-model:value="formState.content"></a-input>
                    </a-form-item>

                    <a-form-item label="机密内容">
                        <a-textarea placeholder="请输入机密内容" v-model:value="formState.secret_content" :rows="3">
                        </a-textarea>
                    </a-form-item>
                    <a-form-item label="紧急情况">
                        <a-radio-group button-style="solid" v-model:value="formState.critical_situation">
                            <a-radio-button :value="1">不急</a-radio-button>
                            <a-radio-button :value="2">普通</a-radio-button>
                            <a-radio-button :value="3">紧急</a-radio-button>
                            <a-radio-button :value="4">最高级</a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                </div>
                <!-- 附加工单end -->
            </div>

            <a-form-item label="支付渠道" required>
                <a-radio-group v-model:value="state.type" button-style="solid" @change="getComputeOreder">
                    <a-radio-button :value="8" v-if="state.allowed_pay_type.indexOf(8) != -1">微信支付</a-radio-button>
                    <a-radio-button :value="4" v-if="state.allowed_pay_type.indexOf(4) != -1">服务商余额支付</a-radio-button>
                    <a-radio-button :value="3" v-if="state.allowed_pay_type.indexOf(3) != -1">平台余额支付</a-radio-button>
                    <a-radio-button :value="1" v-if="state.allowed_pay_type.indexOf(1) != -1">对公账户</a-radio-button>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="续费类型" v-if="formState.public_payment_type == 2" required>
                <a-radio-group v-model:value="formState.fee_standard" button-style="solid" @change="getComputeOreder">
                    <a-radio-button :value="1">按年续费</a-radio-button>
                    <a-radio-button :value="2" :disabled="state.allowed_yicixing !== 1">{{
                        state.allowed_yicixing
                            == 1 ?
                            '一次性续费' : '一次性续费（暂不支持）'
                    }}</a-radio-button>
                </a-radio-group>
            </a-form-item>
            <a-form-item label=" 代理商拿货按年续费价格" v-if="formState.public_payment_type == 2 && formState.fee_standard == 1">
                <span class="red"> ￥{{ props.tableColumnsData.dls_xf_price }} / 年 </span>
            </a-form-item>

            <!-- 服务商余额充值 -->
            <PlatformBalanceCharge v-if="state.platformVisible" @cancel="handleCancel" @ok="handleOk"
                :customerPlatformId="props.tableColumnsData.platform_id" :bussType="1">
            </PlatformBalanceCharge>
            <!-- 平台余额充值 -->
            <PlatformBalanceCharge v-if="state.platformVisible2" @cancel="handleCancel" @ok="handleOk"
                :platformId="props.tableColumnsData.platform_id" :bussType="2">
            </PlatformBalanceCharge>

            <a-form-item label="续费时长" v-if="formState.public_payment_type == 2 && formState.fee_standard == 1"
                name="month_quantity" required>
                <a-select allow-clear v-model:value="formState.month_quantity" placeholder="请选择续费时长"
                    @change="getComputeOreder">
                    <a-select-option v-for="(item, index) in timesOption" :key="item.value"> {{ item.label
                        }}</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item label="一次性付费续费金额" v-if="formState.public_payment_type == 2 && formState.fee_standard == 2">
                <span class="red" v-if="formState.price > 0"> ￥{{ formState.price }} </span>
                <span v-else>-</span>
                <loading-outlined v-if="state.priceLoading" />
            </a-form-item>

            <a-form-item label="附件" :required="state.type == 1 ? true : false">
                <Upload :upload_path="props.tableColumnsData.upload_path"
                    :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" @uploading="
                        (val) => {
                            state.finishLoading = val
                        }
                    " :customerName="props.tableColumnsData.entityNameToRegister.full_name" uploadType="text"
                    v-model:value="formState.attachment" :limitation="99" uploadText="上传附件">
                </Upload>
            </a-form-item>
            <div v-if="state.type == 1">
                <a-form-item label="对公账号信息">
                    <a-tag v-html="state.bank_info" v-if="state.bank_info" color="orange"
                        @click="handleCopyClick(state.bank_info)" style="cursor: pointer;"></a-tag>
                </a-form-item>

                <a-form-item label="是否多公司付款" name="is_duo"
                    v-if="formState.public_payment_type == 1 || formState.public_payment_type == 2">
                    <a-radio-group v-model:value="formState.is_duo" button-style="solid">
                        <a-radio-button :value="1">是</a-radio-button>
                        <a-radio-button :value="2">否</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="更多公司名称" name="is_duo_name" v-if="formState.is_duo == 1">
                    <a-select allow-clear placeholder="请输入公司名称" style="width: 600px" optionLabelProp="label"
                        v-model:value="companyData.companyName" show-search :default-active-first-option="false"
                        :show-arrow="false" :filter-option="false" :not-found-content="null" @search="handleSearch"
                        @change="handleChange">
                        <a-select-option v-for="(optionsItem, optionsIndex) in state.options" :key="optionsIndex"
                            :value="optionsItem.id" :label="optionsItem.full_name" :title="optionsItem">
                            <a-tooltip>
                                <template #title> {{ optionsItem.full_name2 }}</template>
                                {{ optionsItem.full_name2 }}
                            </a-tooltip>
                        </a-select-option>
                    </a-select>
                    <div>
                        <a-row>
                            <a-col :span="12">{{ props.tableColumnsData.full_name }}</a-col>
                            <a-col :span="8">到账金额：{{ calcDaozhangMoney }}元</a-col>
                            <a-col :span="4"></a-col>
                        </a-row>
                        <a-row v-for="item in formState.is_duo_list">
                            <a-col :span="12">{{ item.full_name }}</a-col>
                            <a-col :span="8"><a-input v-model:value="item.public_money" placeholder="到账金额"
                                    addonAfter="元" style="width: 150px"></a-input></a-col>
                            <a-col :span="4">
                                <CloseCircleOutlined style="color: red" @click="delDuoItem(item)" />
                            </a-col>
                        </a-row>
                    </div>
                </a-form-item>
                <a-form-item label="该笔转账到账金额" name="public_money" required>
                    <a-input v-model:value="formState.public_money" placeholder="请输入该笔转账到账金额"></a-input>
                </a-form-item>
            </div>

            <a-form-item label="备注">
                <a-textarea v-model:value="formState.remark" placeholder="请输入备注"></a-textarea>
            </a-form-item>
            <a-form-item label="日志">
                <a @click="onViewLogClick">查看日志</a>
            </a-form-item>
            <a-form-item label="付款方" v-if="state.type == 8">
                <a-radio-group v-model:value="formState.wx_payer" button-style="solid" @click="changeWxPayer">
                    <a-radio-button :value="1">代理商身份付款</a-radio-button>
                    <a-radio-button :value="2">续费联系人身份付款</a-radio-button>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="总计需要支付金额"
                v-if="formState.public_payment_type == 1 || formState.public_payment_type == 2">
                <template v-if="state.type == 8 && formState.wx_payer == 2" title="续费联系人付款">
                    <div>
                        <div v-if="state.cust_paid_editable">
                            <a-input v-model:value="state.cust_paid_total" style="width: 80px"
                                @pressEnter="saveCustPrice()" />
                            <check-outlined class="editable-cell-icon-check" @click="saveCustPrice()" />
                        </div>
                        <div v-else>
                            <span style="font-size: 24px; color: red; line-height: 24px" class="red">￥{{
                                state.cust_paid_total }}</span>
                            <edit-outlined class="editable-cell-icon" @click="editCustPrice()" />
                        </div>
                    </div>
                </template>
                <template v-else title="代理商付款">
                    <div style="font-size: 24px; color: red; line-height: 24px">
                        <div v-if="state.coupon_use_id >= 1">
                            <span class="red" style="text-decoration: line-through">￥{{ state.pay_amount_total }}
                            </span>
                            <span>，优惠了￥{{ state.discount_amount_total }}</span>
                            <a-button type="primary" @click="useCoupon" style="background: #ff6b26; margin-left: 10px"
                                size="small" v-if="state.isselected_coupon">使用了优惠券（{{
                                    state.isselected_coupon.coupon_type == 1 ? '直减现金券' : state.isselected_coupon.coupon_type
                                        == 2 ? '满减现金券' : '折扣券' }}：{{
                                    state.isselected_coupon.name
                                }}√）</a-button>
                            <a style="margin-left: 20px; font-size: 14px" @click="deleteCoupon">删除优惠券</a>
                        </div>
                        <div v-else>
                            ￥{{ state.actually_paid_total }}
                            <a-button type="primary" @click="useCoupon" style="background: #ff6b26; margin-left: 10px"
                                size="small">使用优惠券</a-button>
                        </div>
                    </div>
                </template>
            </a-form-item>
            <a-form-item v-if="formState.public_payment_type == 3 && state.type == 8 && formState.wx_payer == 2"
                label="续费联系人付款金额" name="other_xf_amount" required>
                <a-input v-model:value="formState.other_xf_amount" placeholder="请输入续费联系人付款金额"></a-input>
            </a-form-item>
            <a-form-item label="总计需要支付金额" v-if="formState.public_payment_type == 3">
                <!-- 其他收入 -->
                <div v-if="state.type == 8 && formState.wx_payer == 2"
                    style="font-size: 24px; color: red; line-height: 24px">
                    <div>￥{{ formState.other_xf_amount }}</div>
                </div>
                <div v-else style="font-size: 24px; color: red; line-height: 24px">
                    <div>￥{{ formState.other_amount }}<loading-outlined v-if="state.priceLoading" /></div>
                </div>
            </a-form-item>
            <a-form-item label="优惠后需要支付金额" v-if="state.coupon_use_id >= 1">
                <div style="font-size: 24px; color: red; margin-top: -4px">￥{{ state.actually_paid_total }}</div>
            </a-form-item>

            <a-form-item label="用户当前服务商余额" v-if="state.type == 4">
                <span class="red"> ￥{{ state.moeny }} <a @click="recharge" class="m-3x">点击充值</a></span>
            </a-form-item>
            <a-form-item label="用户当前平台余额" v-if="state.type == 3">
                <span class="red"> ￥{{ state.walletPlatform }} <a @click="platformRecharge" class="m-3x">点击充值</a></span>
            </a-form-item>
            <div v-if="state.type == 8">
                <!-- 微信支付 -->
                <a-form-item label="操作">
                    <a-button type="primary" @click="onFormSubmit" style=" margin-top: 10px" danger>立即扫码付款</a-button>
                </a-form-item>
            </div>
        </a-form>
        <UseCoupons v-if="state.showCoupon" v-model:couponId="state.couponId"
            :tableColumnsData="{ public_payment_type: formState.public_payment_type, customer_list: null, id: props.tableColumnsData.id, fee_standard: formState.fee_standard }"
            @cancel="
                () => {
                    state.showCoupon = false
                }
            " @ok="UseCouponsOk"></UseCoupons>
        <ElectronicProof v-if="state.showModal" :counterfeitInfo="state.counterfeitInfo" @cancel="closeModal">
        </ElectronicProof>
        <view-log :logTabsKey="1" v-if="state.visibleLog" :tableColumnsData="props.tableColumnsData" @cancel="
            () => {
                state.visibleLog = false
            }
        "></view-log>
    </a-modal>
    <!-- 微信扫码支付 -->
    <WechatPayQrcode v-if="state.showQrcode" :qrcodeData="state.qrcodeData" @cancel="state.showQrcode = false" @ok="
        () => {
            emit('ok')
        }
    "></WechatPayQrcode>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import { PlusOutlined, EditOutlined, CheckOutlined, CloseCircleOutlined } from '@ant-design/icons-vue'
import baseService from '@/utils/http/axios'
import { LoadingOutlined } from '@ant-design/icons-vue'
import { reactive, onMounted, ref, computed, onUnmounted } from 'vue'
import ViewLog from './ViewLog.vue'
import Upload from '@/components/base/Upload.vue'
import ElectronicProof from './ElectronicProof.vue'
import PlatformBalanceCharge from './../../financialManagement/components/PlatformBalanceCharge.vue'
import UseCoupons from '@/components/base/UseCoupons.vue'
import WechatPayQrcode from '@/components/base/WechatPayQrcode.vue'
import UserPick from '@/components/base/UserPick.vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
const arrayMonent = dayjs('00:00:00', 'HH:mm:ss')
const format = 'YYYY-MM-DD HH:mm:ss'
const $store = useStore()
const router = useRouter()
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 14 },
        sm: { span: 14 }
    }
}
const ruleForm = ref()
const rules = []
const emit = defineEmits(['cancel', 'ok'])

const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})
const timesOption = [
    { label: '1年', value: 12 },
    { label: '2年', value: 24 },
    { label: '3年', value: 36 },
    { label: '4年', value: 48 },
    { label: '5年', value: 60 },
    { label: '1月', value: 1 },
    { label: '2月', value: 2 },
    { label: '3月', value: 3 },
    { label: '4月', value: 4 },
    { label: '5月', value: 5 },
    { label: '6月', value: 6 },
    { label: '7月', value: 7 },
    { label: '8月', value: 8 },
    { label: '9月', value: 9 },
    { label: '10月', value: 10 },
    { label: '11月', value: 11 }
]

const state = reactive<any>({
    loading: false,
    showModal: false,
    finishLoading: false,
    visibleLog: false,
    priceLoading: false,
    counterfeitInfo: {},
    showCoupon: false,

    discount_amount_total: 0, // 总优惠金额
    pay_amount_total: 0, // 总应付金额
    actually_paid_total: 0, // 总实付金额（代理商）
    customer_xfdata: [],
    cust_paid_total: 0, // 总实付金额（客户）
    cust_paid_editable: false,

    coupon_use_id: null, // 选中优惠券id
    isselected_coupon: {}, //选中的优惠券
    moeny: 0.0,
    walletPlatform: 0.0,
    type: 8,
    platformVisible: false,
    platformVisible2: false,
    showQrcode: false,
    qrcodeData: {},

    allowed_pay_type: [], //允许支付方式
    bank_info: '', //对公转账银行信息
})

const formState = reactive<any>({
    public_payment_type: 0, //地址续费
    fee_standard: 1,
    month_quantity: 12,
    price: props.tableColumnsData.price,
    other_amount: 0,
    other_xf_amount: 0,//其他收入如果是续费联系人支付微信
    other_name: '',
    wx_payer: 1, //微信支付付款人，1代理商，2续费联系人
    is_work_order: null, //工单内容
    wo_type: '',
    reception_admin_ids: [],
    custodian_admin_ids: [],
    start_time: null,
    end_time: null,
    content: '',
    secret_content: '',
    critical_situation: 1,
    is_duo: 2,//是否多公司一起对公转账
    is_duo_list: [],
})
onMounted(() => {
    formState.belonger = props.tableColumnsData.seller
    formState.public_payment_type = props.tableColumnsData.first_pay_time ? (props.tableColumnsData.fee_standard == 2 ? 3 : 2) : 1
    formState.fee_standard = props.tableColumnsData.fee_standard
    queryMoney()
    getComputeOreder()
    //工单默认值
    formState.reception_admin_ids.push(props.tableColumnsData.seller_id)
    formState.start_time = dayjs()
    formState.end_time = dayjs().add(2, 'day')
    //获取平台的异常投诉专员
    let requestParam = {
        url: '/admin/v1/workOrder/getPlatformYctsAdmin',
        method: 'post',
        data: {
            platform_id: props.tableColumnsData.platform_id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            formState.custodian_admin_ids = res.data
        })
        .catch((res) => { })
})
const initPage = (wo_type) => {
    if (wo_type == '小规模转一般纳税人') {
        formState.public_payment_type = 3
        formState.other_name = '小规模转一般纳税人'
        getComputeOreder()
    }
}
const useCoupon = () => {
    state.showCoupon = true
}
const deleteCoupon = () => {
    state.isselected_coupon = {}
    state.coupon_use_id = null
    getComputeOreder()
}
const UseCouponsOk = (e) => {
    state.coupon_use_id = e.id
    state.isselected_coupon = e
    state.showCoupon = false
    getComputeOreder()
}
const handleCancel = () => {
    state.platformVisible = false
    state.platformVisible2 = false
    queryMoney()
}
const handleOk = () => {
    state.platformVisible = false
    state.platformVisible2 = false
    queryMoney()
}

const queryMoney = async () => {
    state.loading = true
    let requeryParam = {
        url: '/admin/user/getMoney?customer_id=' + props.tableColumnsData.id,
        method: 'get'
    }
    await baseService(requeryParam)
        .then((res) => {
            state.loading = false
            state.moeny = res.data.money
            state.walletPlatform = res.data.walletPlatform
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取余额失败')
            }
        })
}
// 查询日志
const onViewLogClick = () => {
    state.visibleLog = true
}

// 跳转平台充值
const recharge = () => {
    state.platformVisible = true
}
const platformRecharge = () => {
    state.platformVisible2 = true
}
const closeModal = () => {
    emit('ok')
}

// 计算订单-地址续费
const getComputeOreder = () => {
    if (formState.public_payment_type == 3) {
        //其他支付
        getComputeOrederOther()
        return
    }
    let obj: any = {
        public_payment_type: formState.public_payment_type, //地址续费
        month_quantity: formState.month_quantity,
        fee_standard: formState.fee_standard, //按年收费
        coupon_use_id: state.coupon_use_id
    }

    if ((formState.public_payment_type == 1 || formState.public_payment_type == 2) && state.type == 1 && formState.is_duo == 1) {
        let customer_list: any = []
        //如果是对公转账的多公司
        if (formState.is_duo_list.length == 0) {
            message.error('请选择其他对公转账公司')
            state.submitLoading = false
            return
        }
        customer_list = formState.is_duo_list.map((item: any) => {
            return {
                customer_id: item.id,
                month_quantity: formState.month_quantity,
                coupon_amount: 0,
                full_name: item.full_name,
                public_money: item.public_money
            }
        })
        customer_list.push({
            customer_id: props.tableColumnsData.id,
            month_quantity: formState.month_quantity,
            coupon_amount: 0,
            full_name: props.tableColumnsData.full_name,
            public_money: 0
        })
        obj.customer_list = customer_list
    } else {
        obj.customer_id = props.tableColumnsData.id
    }

    state.priceLoading = true
    let requeryParam = {
        url: `/admin/v1/getComputeOreder`,
        method: 'post',
        data: obj
    }
    baseService(requeryParam)
        .then((res: any) => {
            state.priceLoading = false
            //state.coupon_use_list = res.data.coupon_use_list
            state.allowed_pay_type = res.data.allowed_pay_type
            state.allowed_yicixing = res.data?.allowed_yicixing
            state.discount_amount_total = res.data.oreder.discount_amount_total // 总优惠金额
            state.pay_amount_total = res.data.oreder.pay_amount_total // 总应付金额
            state.actually_paid_total = res.data.oreder.actually_paid_total // 总实付金额(代理商)
            state.cust_paid_total = res.data.oreder.cust_paid_total // 总实付金额（客户）
            state.customer_xfdata = res.data.oreder.customer_xfdata //
            state.bank_info = res.data.bank_info
            //这里显示
            formState.price = state.pay_amount_total
            //默认选中支持的支付方式
            if (state.allowed_pay_type.indexOf(state.type) == -1) {
                state.type = state.allowed_pay_type[0]
            }


        })
        .catch((res) => {
            message.error(res?.msg ? res.msg : '查询订单失败')
            state.priceLoading = false
            if (res?.data == 'coupon') {
                //优惠券问题，删除此优惠券
                deleteCoupon()
            }
        })
}
const getComputeOrederOther = () => {
    if (formState.other_name == '小规模转一般纳税人') {
        state.priceLoading = true
        let requeryParam = {
            url: `/admin/v1/getComputeOrederOther`,
            method: 'post',
            data: {
                other_name: formState.other_name,
                customer_id: props.tableColumnsData.id
            }
        }
        baseService(requeryParam)
            .then((res: any) => {
                state.priceLoading = false
                state.allowed_pay_type = res.data.allowed_pay_type
                formState.other_amount = res.data.actually_paid_total // 总实付金额(代理商)
                state.bank_info = res.data.bank_info
                //默认选中支持的支付方式
                if (state.allowed_pay_type.indexOf(state.type) == -1) {
                    state.type = state.allowed_pay_type[0]
                }
            })
            .catch((res) => {
                console.log(res)
                message.error(res?.msg ? res.msg : '查询订单失败')
                state.priceLoading = false
            })
    } else {
        formState.other_amount = 0
    }
}
// 改变付款对象
const changeWxPayer = () => {
    console.log(formState.wx_payer)
}
// 提交
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            let obj: any = {}
            if (state.type == 4 || state.type == 3) {
                //账户余额
                obj = {
                    public_payment_type: formState.public_payment_type, //地址续费
                    customer_id: props.tableColumnsData.id, //客户id
                    fee_standard: formState.fee_standard, //续费类型
                    month_quantity: formState.month_quantity, //续费月份
                    belonger: null, //代理商、这里没有变更代理商
                    coupon_use_id: state.coupon_use_id, //余额抵扣可以用优惠券
                    payment_method: state.type, // 4服务商余额支付，3平台余额支付
                    remark: formState.remark, //付款备注
                    attachment: formState.attachment, //附件、续费都有附件
                    other_amount: formState.other_amount, //其他金额
                    other_name: formState.other_name //支付名称
                }
            } else if (state.type == 8) {
                //微信支付
                obj = {
                    public_payment_type: formState.public_payment_type, //地址续费
                    customer_id: props.tableColumnsData.id, //客户id
                    fee_standard: formState.fee_standard, //续费类型
                    month_quantity: formState.month_quantity, //续费月份
                    belonger: null, //代理商、这里没有变更代理商
                    coupon_use_id: state.coupon_use_id, //余额抵扣可以用优惠券
                    payment_method: 8, //微信支付
                    remark: formState.remark, //付款备注
                    attachment: formState.attachment, //附件、续费都有附件
                    other_amount: formState.other_amount, //其他金额
                    other_xf_amount: formState.other_xf_amount, //其他金额如果是续费联系人
                    other_name: formState.other_name, //支付名称
                    wx_payer: formState.wx_payer //微信支付特有的2项
                }
            } else {
                //对公账户
                obj = {
                    public_payment_type: formState.public_payment_type, //地址续费
                    fee_standard: formState.fee_standard, //收费时间
                    month_quantity: formState.month_quantity,
                    belonger: formState.belonger, //代理商
                    coupon_use_id: null, //对公不能使用优惠券
                    payment_method: 1, //对公转账
                    remark: formState.remark, //付款备注
                    attachment: formState.attachment, //附件、对公才传附件
                    other_amount: formState.other_amount, //其他金额
                    other_name: formState.other_name, //支付名称
                    public_money: formState.public_money
                }
                if (formState.is_duo == 1) {
                    if (formState.is_duo_list.length == 0) {
                        message.error('请选择其他对公转账公司')
                        state.submitLoading = false
                        return
                    }
                    let shengyu = formState.public_money
                    let err = false
                    formState.is_duo_list.forEach((item: any) => {
                        if (!item.public_money || item.public_money <= 0) {
                            message.error('请输入每个主体对公转账金额')
                            state.submitLoading = false
                            err = true
                            return
                        }
                        shengyu -= item.public_money
                    })
                    if (err) {
                        return
                    }
                    if (shengyu <= 0) {
                        message.error('对公转账金额不能大于总金额')
                        state.submitLoading = false
                        return
                    }
                    obj.customer_list = formState.is_duo_list.map((item: any) => {
                        return {
                            customer_id: item.id,
                            month_quantity: formState.month_quantity,
                            coupon_amount: 0,
                            full_name: item.full_name,
                            public_money: item.public_money
                        }
                    })
                    obj.customer_list.push({
                        customer_id: props.tableColumnsData.id,
                        month_quantity: formState.month_quantity,
                        coupon_amount: 0,
                        full_name: props.tableColumnsData.full_name,
                        public_money: shengyu
                    })
                } else {
                    obj.customer_id = props.tableColumnsData.id
                }
            }
            let requeryParam = {
                url: '/admin/v1/payOreder',
                method: 'post',
                data: obj
            }
            if (formState.public_payment_type == 3) {
                requeryParam.url = '/admin/v1/payOrederOther'
                //其他支付需要的工单
                requeryParam.data.is_work_order = formState.is_work_order
                requeryParam.data.wo_type = formState.wo_type
                requeryParam.data.reception_admin_ids = formState.reception_admin_ids
                requeryParam.data.custodian_admin_ids = formState.custodian_admin_ids
                requeryParam.data.start_time = formState.start_time
                requeryParam.data.end_time = formState.end_time
                requeryParam.data.content = formState.content
                requeryParam.data.secret_content = formState.secret_content
                requeryParam.data.critical_situation = formState.critical_situation
            }
            baseService(requeryParam)
                .then((res: any) => {
                    state.loading = false
                    if (res.msg == 'showqrcode') {
                        //显示微信扫的二维码
                        state.qrcodeData = {
                            qrcode: res.data.code_url, //二维码url
                            qrcode_money: res.data.qrcode_money, //金额
                            payment_record_id: res.data.payment_record_id, //记录id
                            full_name: props.tableColumnsData.full_name, //名称
                            trade_type: res.data.trade_type
                        }
                        state.showQrcode = true
                    } else {
                        message.success(res.msg)
                        //   emit('ok')
                        if (state.type == 4) {
                            //余额续费显示一下凭证
                            state.showModal = true
                            state.counterfeitInfo = res.data
                        } else {
                            closeModal()
                        }
                    }
                })
                .catch((res) => {
                    state.loading = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        })
        .catch(() => { })
}
const cancel = () => {
    emit('cancel')
}
//编辑续费联系人付款
const editCustPrice = () => {
    state.cust_paid_editable = true
}
const saveCustPrice = () => {
    let requeryParam = {
        url: '/admin/v1/updateCustPaid',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id, //客户id
            new_price: state.cust_paid_total,
            month_quantity: formState.month_quantity,
            public_payment_type: formState.public_payment_type
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            message.success(res.msg)
            state.cust_paid_editable = false
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('修改失败')
            }
        })
}
// 复制
const handleCopyClick = (val) => {
    // 将HTML转换为带换行符的文本
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = val

    // 获取所有div内容并过滤掉空内容，然后用换行符连接
    const divs = tempDiv.getElementsByTagName('div')
    const textArray = Array.from(divs)
        .map(div => div.textContent || div.innerText)
        .filter(text => text.trim() !== '')  // 过滤掉空内容

    // 使用一个换行符连接
    const plainText = textArray.join('\n')

    // 使用textarea保存格式
    var textarea = document.createElement('textarea')
    textarea.value = plainText
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    message.success('复制成功!')
    document.body.removeChild(textarea)
}
defineExpose({
    initPage   // 可以暴露多个方法，用逗号隔开
})
//对公转账多个公司的相关方法
const companyData = reactive<any>({})
let timer: any = null
const handleSearch = (e) => {
    clearTimeout(timer)
    if (e == '') {
        state.options = []
        return
    }
    timer = setTimeout(() => {
        let requestParam = {
            url: '/admin/v1/customerSearchAll?checkpermission=2&keyword=' + e + '&platform_id=' + props.tableColumnsData.platform_id,
            method: 'get'
        }
        baseService(requestParam)
            .then((res) => {
                state.options = res.data.list
            })
            .catch((res) => {
                state.options = []
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('查询失败')
                }
            })
    }, 500)
}
const handleChange = (e, val) => {
    if (val.title.checkpermission == 2) {
        message.error('您没有此平台的万能支付权限')
        companyData.companyName = ''
        return
    } else if (val.title.checkpermission == 3) {
        message.error('该主体在续费保护期内，只能由原代理商续费，请联系原代理商协商！')
        companyData.companyName = ''
        return
    }
    if (val.title.id != props.tableColumnsData.id) {//不能添加当前单位
        //判断list中是否有数据
        let haveId = formState.is_duo_list.find((item) => {
            return item.id == val.title.id
        })
        if (!haveId) {
            formState.is_duo_list.push({
                id: val.title.id,
                full_name: val.title.full_name,
                public_money: 0,
            })
            getComputeOreder()
        }
    }
    companyData.companyName = ''
}
const delDuoItem = (val) => {
    formState.is_duo_list = formState.is_duo_list.filter((item) => {
        return item.id != val.id
    })
}
// 定义计算属性
const calcDaozhangMoney = computed(() => {
    let total = formState.public_money ?? 0
    formState.is_duo_list.forEach((item) => {
        let son_money = item.public_money ?? 0
        total -= son_money
    })
    return total.toFixed(2)
})

</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
    margin-bottom: 15px;
}

.d-flex {
    align-items: center;
}
</style>
<style lang="less">
.addresssRenewModal {
    .ant-modal {
        top: 300px;
    }
}
</style>
